module.exports = __webpack_public_path__ + "static/media/event-services-img46.81f68bd6.jpg";